import * as React from "react";
import type { SVGProps } from "react";
const SvgMultiFactorAuthentication = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M5.664 10.88a3.855 3.855 0 0 0-3.855 3.856v30.58a3.855 3.855 0 0 0 3.855 3.855h42.462v1.752H5.664a5.607 5.607 0 0 1-5.607-5.607v-30.58a5.607 5.607 0 0 1 5.607-5.607H51.26a5.607 5.607 0 0 1 5.607 5.607v11.463h-1.752V14.736a3.855 3.855 0 0 0-3.855-3.856H5.664Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M61.953 26.772H49.03a.295.295 0 0 0-.295.296v28.94c0 .164.132.296.295.296h12.924a.295.295 0 0 0 .295-.295V27.067a.295.295 0 0 0-.295-.295ZM49.03 25.02h12.924c1.13 0 2.047.917 2.047 2.047V56.01c0 1.13-.916 2.047-2.047 2.047H49.03a2.047 2.047 0 0 1-2.047-2.047V27.067c0-1.13.916-2.047 2.047-2.047Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M2.062 9.081h16.842c.624 0 1.13.506 1.13 1.13v10.677a1.13 1.13 0 0 1-1.13 1.13H2.062a1.13 1.13 0 0 1-1.13-1.13V10.21c0-.624.506-1.13 1.13-1.13Zm11.222 5.542c0 1.04-.55 1.95-1.37 2.446l.265.67a1.19 1.19 0 0 1-1.107 1.625H9.898A1.19 1.19 0 0 1 8.79 17.74l.263-.669a2.852 2.852 0 0 1-1.371-2.447c0-1.571 1.254-2.845 2.8-2.845 1.547 0 2.8 1.274 2.8 2.845Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M6.52 1.927a.197.197 0 0 0-.198.198v6.632a.932.932 0 0 1-1.865 0V2.125C4.457.986 5.38.063 6.519.063h7.928c1.139 0 2.062.923 2.062 2.062v6.632a.932.932 0 0 1-1.865 0V2.125a.198.198 0 0 0-.197-.198H6.519Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M0 10.211c0-1.139.923-2.062 2.062-2.062h16.842c1.138 0 2.062.923 2.062 2.062v10.677a2.062 2.062 0 0 1-2.062 2.062H2.062A2.062 2.062 0 0 1 0 20.888V10.21Zm2.062-.197a.197.197 0 0 0-.197.197v10.677c0 .109.088.197.197.197h16.842a.198.198 0 0 0 .197-.197V10.21a.198.198 0 0 0-.197-.197H2.062Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M60.578 38.38a.876.876 0 0 1 .072 1.238l-5.936 6.678-3.326-3.118a.876.876 0 0 1 1.198-1.278l2.014 1.888 4.741-5.334a.876.876 0 0 1 1.237-.073Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M29.088 62.185V49.046h1.752v13.14h14.14a.876.876 0 0 1 0 1.751H14.948a.876.876 0 1 1 0-1.752h14.14Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M5.938 29.275c0-.69.56-1.251 1.251-1.251h36.54a1.251 1.251 0 0 1 0 2.503H7.188c-.69 0-1.251-.56-1.251-1.252ZM5.938 33.78c0-.69.56-1.251 1.251-1.251h36.54a1.251 1.251 0 0 1 0 2.502H7.188c-.69 0-1.251-.56-1.251-1.25ZM5.938 38.285c0-.691.56-1.251 1.251-1.251h36.54a1.251 1.251 0 1 1 0 2.502H7.188c-.69 0-1.251-.56-1.251-1.251Z"
    />
  </svg>
);
export default SvgMultiFactorAuthentication;
